import React from 'react'

import ContentContainer from '../Commons/ContentContainer'

const Contact = () => {
  return <ContentContainer>Contact</ContentContainer>
}

export default Contact
